export default __webpack_public_path__ + "static/media/solution_11.5867cc71.png";